import { TextField } from '@material-ui/core';
import React from 'react';

import MuiCss from '../../../assets/css/MuiCss';
import NumberFormat from 'react-number-format';
import AdornmentState from './AdornmentState';
import InputEvents from './InputEvents';
import StringUtil from '../../../app/util/StringUtil';
import GoogleTagManager from '../../../gtm/GoogleTagManager';
import GtmFormularfeldId, { createGtmFieldId } from '../../../gtm/types/GtmFormularfeldId';

const NumberInputCmp = ({ ...props }) => {
    const { value, inputRef, ...other } = props;
    return <NumberFormat {...other} value={value} allowNegative={false} allowLeadingZeros={true}/>
};

const InputModeCmp = {
    "text": undefined,
    "email": undefined,
    "numeric": NumberInputCmp,
}

type Param = {

    onBlur?: (event: any) => void,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    // Soll die blur()-Funktion beim Drücken von ENTER aufgerufen werden?
    blurOnEnter?: boolean | false,
    preventSubmitOnEnter?: boolean | true,
    value?: string,
    label?: string,
    id: string,
    idGtm: GtmFormularfeldId,
    idGtmIndex?: number
    error?: boolean,
    helperText?: string,
    required?: boolean,
    placeholder?: string,
    inputModeType?: "text" | "email" | "numeric" | undefined,
    maxLength?: number,
    // | "none" | "search" | "tel" | "url" | "numeric" | "decimal"
}

const TextInputField: React.FC<Param> = ({ onBlur, onChange, blurOnEnter, preventSubmitOnEnter = true, value, label, id, idGtm, idGtmIndex, error, helperText, required, placeholder, inputModeType = "text", maxLength }) => {
    const inputCmp = InputModeCmp[inputModeType];

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        const newValue = StringUtil.replaceCrossSiteScripting(value);
        event.target.value = newValue || '';
        onChange(event);
    }

    const handleOnFocus = () => {
        const gtmFieldId = createGtmFieldId(idGtm, idGtmIndex);
        GoogleTagManager.fireEventFormularfeld(gtmFieldId);
    }

    const onKeyPressEnter = (event: any) => {
        if (preventSubmitOnEnter === true) {
            InputEvents.preventOnKeyPressEnter(event);
        }
        if (blurOnEnter === true && (event.key === 'Enter')) {
            if (onBlur !== undefined) {
                onBlur(event);
            }
        }
    }

    return (
        <TextField id={id} label={label}
            autoComplete="off-even-for-chrome"
            classes={MuiCss.muiTextFieldModuleCss}
            color='primary'
            value={value}
            onFocus={handleOnFocus}
            onBlur={onBlur}
            onChange={handleOnChange}
            onKeyPress={onKeyPressEnter}
            error={error}
            required={required}
            InputProps={{
                classes: MuiCss.muiInputModuleCss,
                inputProps: {
                    inputMode: inputModeType,
                    maxLength: maxLength
                },
                inputComponent: inputCmp as any,
                endAdornment: <AdornmentState error={error} />
            }}
            InputLabelProps={{
                classes: MuiCss.muiInputLabelModuleCss,
                shrink: value ? true : undefined,
            }}
            helperText={helperText}
            placeholder={placeholder}

        />
    );
}

export default TextInputField;